import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBeta: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="beta"><path d="M7.83011 14.0441V8.38235C7.83011 5.82398 9.91517 3.75 12.5 3.75C17.7769 3.75 18.5 11.25 12.75 11.25M7.83011 14.0441V19.1699C7.83011 20.3187 6.89881 21.25 5.75 21.25M7.83011 14.0441C7.83011 16.8868 9.62797 19.25 12.5 19.25C18.4696 19.25 19.5 11.25 13 11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBeta;
